module.exports = __webpack_public_path__ + "static/media/coin-wooden-table.1a215ee5.jpg";